import { render } from "./RdvPrealable.vue?vue&type=template&id=55cb9f0b&scoped=true"
import script from "./RdvPrealable.vue?vue&type=script&lang=js"
export * from "./RdvPrealable.vue?vue&type=script&lang=js"

import "./RdvPrealable.vue?vue&type=style&index=0&id=55cb9f0b&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cb9f0b"]])

export default __exports__